import { DesignSourceEnum } from '@insights/insights-data-provider'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import { sofaTypes } from '@sofa-platform/range-data-generator/type-object'

import { DocumentTitleWithCurrentSofa } from '@/components/document-title'
import { SceneLayout } from '@/components/scene-layout'
import { usePlaceSofaOnScene } from '@/hooks/use-place-sofa-on-scene'
import { httpPrefetchModelData } from '@/integrations/core/utils'
import { getUserFlowBasedOnPlatform } from '@/integrations/insights/user-flow'
import { initPlanningSessionQueryOptions } from '@/query-options'
import { getPlatform } from '@/utils/get-platform'

const pathParamsSchema = z.object({
  country: z.string().length(2),
  language: z.string().length(2),
  id: z.string().length(8, 'Invalid product id'),
  rangeId: z.enum([...Object.keys(sofaTypes), 'future'], 'Invalid rangeId'),
})

export const Route = createFileRoute('/$country/$language/navigator/$rangeId/$id')({
  params: {
    parse: (rawParams) => pathParamsSchema.parse(rawParams),
  },
  component: SceneRoute,
  loaderDeps: ({ search: { origin, ipexGallery } }) => ({
    origin,
    ipexGallery,
  }),
  loader: ({ params, context, preload, location, deps }) => {
    httpPrefetchModelData(params.id)

    if (!preload && !location.state.skipHistory) {
      context.sceneHistory.addOrMoveToEnd({ id: params.id, rangeId: params.rangeId })
    }

    if (!preload && location.href !== window.location.pathname) {
      const designSource = location.state.fromGallery ? DesignSourceEnum.gallery : DesignSourceEnum.spr
      void context.queryClient.fetchQuery(initPlanningSessionQueryOptions(context.insightsApi, params.id, designSource))
      const platform = getPlatform(deps)
      const { flowName, availableSteps } = getUserFlowBasedOnPlatform(platform)
      void context.insightsApi?.sendUserFlowStep(flowName, availableSteps.SCENE, 2)
    }
  },
})

function SceneRoute() {
  const { id } = Route.useParams()

  usePlaceSofaOnScene(id)

  return (
    <>
      <DocumentTitleWithCurrentSofa />
      <SceneLayout />
    </>
  )
}
